enum JobStatus {
  New = 'new',
  OnHold = 'on_hold',
  Routing = 'routing',
  Routed = 'routed',
  Canceled = 'canceled',
  Picked = 'picked',
  Dropped = 'dropped',
  Noshow = 'noshow',
  Queued = 'queued',
}

export default JobStatus;